import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import {
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { Flex, Typography } from '@aloft/toolkit-sui';
import { computeTrend } from '../../utils/computeTrend.ts';


export const TotalComparableListings = ({
  data,
  disableAnimations = false,
}: {
  data: AbodeAggregateMarketConditions;
  disableAnimations?: boolean;
}) => {
  const chartData: {
    month: string;
    totalComparableListings: number;
  }[] = data.monthlyData.filter((item) => item.absorption_rate !== null && item.total_comparable_sales !== null).map((item => ({
    month: item.month.substring(0, 7),
    totalComparableListings: item.total_active_properties ?? 0,
  })))
  const maxValue = Math.max(...chartData.map(item => item.totalComparableListings));
  const trendSeries = computeTrend(chartData, 'totalComparableListings');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { totalComparableListings: 0 }).totalComparableListings >= (trendSeries[0] || { totalComparableListings: 0 }).totalComparableListings
      ? '#00B050'
      : '#FF0000';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Total # of Comparable Active Listings</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={chartData}
          margin={{ top: 80, right: 40, left: 0, bottom: 0 }}
        >
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line type="linear" dataKey="totalComparableListings" stroke="#3455DB" strokeWidth={2} dot={{ r: 3 }} isAnimationActive={!disableAnimations} >
            <LabelList dataKey="totalComparableListings" position="top" fontSize={12} offset={10} />
          </Line>
          <Line type="linear" data={trendSeries} dataKey="totalComparableListings" stroke={trendSeriesColor} strokeWidth={1} dot={false} strokeDasharray="5 5" isAnimationActive={!disableAnimations} />
        </LineChart>
      </ResponsiveContainer>
    </Flex>
  );
}
